import { List, Map, Record, fromJS } from 'immutable'

const PRIMARY_RELS = [
  'player',
  'thumbnail',
  'app',
  'image',
  'reader',
  'survey',
  'summary',
  'icon',
  'logo',
]

const getPrimaryRel = (card) => {
  return card.rel
    .filter((rel) => PRIMARY_RELS.indexOf(rel) !== -1)
    .first()
}

const getPreferreredIcon = (card) => {
  return card.links.get('icon', List())
    .filter((icon) => icon.getIn(['media', 'width'], 0) >= 16)
    .sortBy((icon) => icon.getIn(['media', 'width'], 0))
    .first()
}

export const CardMeta = Record({
  title: undefined,
  description: undefined,
  author_url: undefined,
  author: undefined,
  site: undefined,
  keywords: undefined,
  canonical: undefined,
})

export const Card = Record({
  url: undefined,
  meta: new CardMeta(),
  links: List(),
  rel: List(),
  html: undefined,
  icon: undefined,
  primaryRel: undefined,
})

export const CardAndStatus = Record({
  href: undefined,
  card: new Card(),
  status: 'pending',
})

export const CardState = Record({
  hrefsByMessageId: Map(),
  cardsByHref: Map(),
})

export const makeCard = (data) => {
  const card = new Card({
    url: data.url,
    meta: new CardMeta(data.meta),
    links: fromJS(data.links),
    rel: List(data.rel),
    html: data.html,
  })

  return card
    .set('primaryRel', getPrimaryRel(card))
    .set('icon', getPreferreredIcon(card))
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/cards/models.js